// eslint-disable-next-line no-shadow
var IotDeviceFunction;
(function (IotDeviceFunction) {
    IotDeviceFunction["RFID"] = "RFID";
    IotDeviceFunction["RECORDING"] = "Recording";
    IotDeviceFunction["DIGITAL_IO"] = "Digital-IO";
    IotDeviceFunction["CAMERA"] = "Camera";
    IotDeviceFunction["DOOR"] = "Door";
})(IotDeviceFunction || (IotDeviceFunction = {}));

export { IotDeviceFunction };
//# sourceMappingURL=iotDeviceFunction.js.map
